import { SelectOption } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  INCIDENCE_STATUSES,
  professionalsStatusCopies,
} from 'modules/payroll_bundle/lib/Incidences/Status'

export interface FilterOption {
  label: string
  value: string
}

export const allActive = () => ({
  label: i18n.t('bookkeepers.incidence.generic_filter.all_active'),
  value: [INCIDENCE_STATUSES.to_do, INCIDENCE_STATUSES.doing].join(','),
})

const allResult = (label?: string) => ({
  value: '',
  label: label ?? i18n.t('bookkeepers.incidence.generic_filter.all'),
})

export const statusOptions = (isBookkeeperView: boolean): SelectOption[] => {
  const status = Object.entries(professionalsStatusCopies(isBookkeeperView)).map(
    ([rawValue, label]) => ({
      value: rawValue,
      label,
    })
  )

  const allResultLabel = i18n.t('bookkeepers.incidence.filters.status')
  return [allResult(allResultLabel), allActive(), ...status]
}
